import { render, staticRenderFns } from "./admin-header.vue?vue&type=template&id=b1fb3992&scoped=true"
import script from "./admin-header.vue?vue&type=script&lang=js"
export * from "./admin-header.vue?vue&type=script&lang=js"
import style0 from "./admin-header.vue?vue&type=style&index=0&id=b1fb3992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fb3992",
  null
  
)

export default component.exports